import { render, staticRenderFns } from "./MedicalProcedures.vue?vue&type=template&id=bcd26598"
import script from "./MedicalProcedures.vue?vue&type=script&lang=js"
export * from "./MedicalProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports